export const CheckSelectedIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9248 4.58057L8.9248 14.0806L4.4248 10.5806"
        stroke="#3643BA"
        strokeWidth="1.5"
      />
    </svg>
  )
}
